<script>

    import Box from '../../components/Box.svelte';

    import { _, locale } from 'svelte-i18n';

    import Icon from '../Icon.svelte';
    import clockIcon from '../../assets/icons/clock.svg?raw';
    import appointmentIcon from '../../assets/icons/appointment.svg?raw';
    import treatmentIcon from '../../assets/icons/treatment.svg?raw';
    import employeeIcon from '../../assets/icons/employee.svg?raw';

    import { DateTime } from 'luxon'

    let { appointment } = $props();

    // Parse timeframes from comma-separated string
    let timeframes = $derived(appointment.time ? appointment.time.split(',') : []);

    const timeframeKeys = {
        morning: 'waitlist_morning',
        afternoon: 'waitlist_afternoon',
        evening: 'waitlist_evening',
    };

    let formattedTimeframes = $derived(
        timeframes.map(t => $_(timeframeKeys[t] || t)).join(', ')
    );

</script>

<Box>
    <div class='waitlist'>
        <Icon data={appointmentIcon} />

        <h3>
            {$_('waitlist_date_label', { values: { date: DateTime.fromSQL(appointment.date).toLocaleString(DateTime.DATE_FULL, { locale: $locale }) } })}
        </h3>

        {#if timeframes.length > 0}
            <Icon data={clockIcon} />
            <p>
                {$_('waitlist_timeframe_label', { values: { timeframes: formattedTimeframes } })}
            </p>
        {/if}

        {#if appointment.treatment?.name}
            <Icon data={treatmentIcon} />

            <p>
                {appointment.treatment.name}
            </p>
        {/if}

        {#if appointment.employee?.id}
            <Icon data={employeeIcon} />

            <p>
                {appointment.employee.name}
            </p>
        {/if}
    </div>
</Box>

<style>

    .waitlist {
        display: grid;
        grid-template-columns: min-content 1fr;
        align-items: center;
        gap: 0.3em 0.8em;
    }

    .waitlist > * {
        margin: 0;
    }

</style>
